import styled from 'styled-components';
import { attachLocale, attachShopSlug, trackAnalytics } from '../../../../lib/utils';
import { DOM_SITEMAP_SHOP_SECTION } from '../../../../lib/constants';
import { SiteMapAnchor, SiteMapAnchorGroup } from './sitemap.shared';

const ShopGroupHeaderDiv = styled.div`
  margin-bottom: ${p => p.theme.unit(2)};
`;

const ShopGroupDiv = styled.div`
  margin-bottom: ${p => p.theme.unit(2)};
`;

const LetterDiv = styled.div`
  ${({ theme }) => theme.typographyRebrand.heading.xl}
  color: ${p => p.theme.c.text.primary};
  margin-top: ${p => p.theme.unit(4)};
`;

const SiteMapShopGroup = (props) => {
  const {
    locale,
    shops,
    letter,
    isMobile = false,
  } = props;

  // Shop links
  const shopsToRender = shops.map((shop) => {
    const {
      tags = {},
      slug = '',
    } = shop;

    const resolvedLocaleLink = attachLocale(attachShopSlug(slug), locale);
    const track = trackAnalytics(DOM_SITEMAP_SHOP_SECTION, `SiteMapShopGroup-${slug}`, resolvedLocaleLink, tags);

    return (
      <SiteMapAnchor
        key={`sub-category-anchor-${shop.slug}`}
        href={track.url}
        data-track-id={track.dataTrackingId}
        data-track-click={track.dataTrack}
      >
        {shop.displayName || shop.name}
      </SiteMapAnchor>
    );
  });

  return (
    <ShopGroupDiv>
      <ShopGroupHeaderDiv>
        <LetterDiv isMobile={isMobile}>{letter}</LetterDiv>
      </ShopGroupHeaderDiv>
      <SiteMapAnchorGroup>
        {shopsToRender}
      </SiteMapAnchorGroup>
    </ShopGroupDiv>
  );
};

export default SiteMapShopGroup;
